var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.47 0.47a0.75 0.75 0 0 1 1.06 0l3.5 3.5a0.75 0.75 0 0 1 0 1.06l-3.5 3.5a0.75 0.75 0 1 1-1.06-1.06l2.22-2.22H1.75a0.75 0.75 0 0 1 0-1.5h12.94l-2.22-2.22a0.75 0.75 0 0 1 0-1.06z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53 7.47a0.75 0.75 0 0 1 0 1.06l-2.22 2.22h12.94a0.75 0.75 0 0 1 0 1.5H3.31l2.22 2.22a0.75 0.75 0 1 1-1.06 1.06l-3.5-3.5a0.75 0.75 0 0 1 0-1.06l3.5-3.5a0.75 0.75 0 0 1 1.06 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.d407bbebf78fbfa826af981c568044bb.svg";
export { ForwardRef as ReactComponent };